// extracted by mini-css-extract-plugin
module.exports = {"Framed":"MeetingPlace_Framed__skjrT"};